import { render, staticRenderFns } from "./WorkerDashboard2.vue?vue&type=template&id=13b20f21&scoped=true&"
import script from "./WorkerDashboard2.vue?vue&type=script&lang=js&"
export * from "./WorkerDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./WorkerDashboard2.vue?vue&type=style&index=0&id=13b20f21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b20f21",
  null
  
)

export default component.exports